import { render, staticRenderFns } from "./DDChooseAmount.vue?vue&type=template&id=3aa39fa0"
import script from "./DDChooseAmount.vue?vue&type=script&lang=js"
export * from "./DDChooseAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports